import { cn } from "@/lib/utils";

export const SiteTabs = ({ active, onChange, sites, total, restrictedKey }) => {
  const allTabs = [
    { key: "ALL", name: "All Sites", count: total },
    ...sites.map((s) => ({ key: s.key, name: s.name, count: s.total })),
  ];
  const tabs = restrictedKey ? allTabs.filter((t) => t.key === restrictedKey) : allTabs;
  return (
    <div className="flex flex-wrap gap-2" data-testid="site-tabs">
      {tabs.map((t) => (
        <button
          key={t.key}
          data-testid={`site-tab-${t.key.toLowerCase().replace(/\s+/g, "-")}`}
          onClick={() => onChange(t.key)}
          className={cn(
            "px-4 py-2 rounded-md text-sm font-semibold transition-all border",
            active === t.key
              ? "bg-slate-900 text-white border-slate-900 shadow-sm"
              : "bg-white text-slate-600 border-slate-200 hover:border-slate-300 hover:text-slate-900"
          )}
        >
          {t.name}
          <span className={cn("ml-2 font-mono-nums", active === t.key ? "text-slate-300" : "text-slate-400")}>
            {t.count}
          </span>
        </button>
      ))}
    </div>
  );
};
